module.exports = __webpack_public_path__ + "img/reg3PS-3.30d99f35.jpg";